<template>
    <div class="claim-chat-dropdown" v-on-click-outside="close">
        <div class="claim-chat-dropdown_title mb-1 pt-1 px-3" v-if="title" @click="isOpen = !isOpen">
            <small>{{ title }}</small>
        </div>
        <div class="claim-chat-dropdown_selected d-flex" @click="isOpen = !isOpen">
            <span v-if="selectedLabel" :style="{color: selectedColor}" class="me-3">
                <template v-if="!isMobile || !isIcon">{{ $t('message.item.'+selectedType) }}</template>
                <template v-else>
                    <font-awesome-icon :icon="['fas', messageIcons[selectedType].icon]" size="md" :style="{color: messageIcons[selectedType].color}" />
                </template>
            </span>
            <span v-else class="me-2">{{ notSelectedLabel }}</span>
            <font-awesome-icon :icon="['fas', 'sort-down']" size="xs" />
        </div>
        <div class="claim-chat-dropdown_items" v-show="isOpen">
            <div class="claim-chat-dropdown_item px-3 py-2 d-flex align-items-center"
                 v-for="item in items"
                 :style="{color: item.color}"
                 :class="{active: selectedValue === item.value, 'd-none': !search(item)}"
                 @click="select(item)" 
                 :key="item.value"
            >
            <font-awesome-icon v-if="isIcon" :icon="['fas', messageIcons[item.type].icon]" size="xs" />
                <span class="ms-2">{{ item.label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { vOnClickOutside } from '@vueuse/components'
import screenMixin from 'mixins/screen'

export default {
    name: 'ClaimChatDropdown',
    emits: ['update:items', 'update:modelValue', 'update:type'],
    directives: {
        onClickOutside: vOnClickOutside
    },
    props: {
        isIcon: {
            type: Boolean,
            default: true
        },
        items: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: Number,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        notSelectedLabel: {
            type: String,
            default: 'Select value'
        }
    },
    data() {
        return {
            isOpen: false,
            selectedLabel: null,
            selectedValue: null,
            selectedType: null,
            selectedColor: null,
            searchField: 'var(--bs-font-color)',
            isMobile: false,
            messageIcons: {
                message: {
                    icon: 'message',
                    color: 'var(--bs-purple)'
                },
                information: {
                    icon: 'circle-info',
                    color: 'var(--bs-primary)'
                },
                congratulation: {
                    icon: 'gift',
                    color: 'var(--bs-green)'
                },
                urgent: {
                    icon: 'bolt-lightning',
                    color: 'var(--bs-yellow)'
                },
                important: {
                    icon: 'triangle-exclamation',
                    color: 'var(--bs-red)'
                }
            }
        }
    },
    methods: {
        select(item) {
            this.searchField = '';
            this.selectedLabel = item.label;
            this.selectedValue = item.value;
            if(item.type)
                this.selectedType = item.type;
            this.selectedColor = item.color;
            if(item.type)
                this.$emit('update:type', item.type);
            this.$emit('update:modelValue', this.selectedValue);
            this.isOpen = false;
        },
        selectByValue(value) {
            const item = this.items.find(item => item.value == value);
            this.select(item);
        },
        search(item) {
            if(this.searchField == '')
                return true;
            return item.label.toLowerCase().indexOf(this.searchField.toLowerCase()) !== -1;
        },
        close() {
            this.isOpen = false;
        }
    },
    watch: {
        modelValue(newVal){
            if(newVal)
                this.selectByValue(newVal);
        }
    },
    mixins: [
        screenMixin
    ],
    beforeMount() {
        if(this.modelValue)
            this.selectByValue(this.modelValue);
            const self = this;
        window.addEventListener('resize', function(){
            self.isMobile = self.isBreakpoint('xs');
        });
        self.isMobile = self.isBreakpoint('xs');
    }
}
</script>

<style scoped>
    .claim-chat-dropdown .form-control{
        box-shadow: none !important;
        border: none !important;
        padding: 0 !important;
    }
    .claim-chat-dropdown_selected svg{
        margin-top: 3px;
    }
    .claim-chat-dropdown_selected span{
        display: block;
    }
    .claim-chat-dropdown{
        position: relative;
        cursor: pointer;
    }
    .claim-chat-dropdown_title, .claim-chat-dropdown_item__search svg{
        color: var(--bs-gray-500);
    }
    .claim-chat-dropdown_items{
        background: #fff;
        position: absolute;
        left: -16px;
        right: -23px;
        top: 30px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        z-index: 1;
        max-height: calc(38px * 10);
        overflow: auto;
    }
    .dark-mode .claim-chat-dropdown_items{
        background: var(--bs-gray-800);
    }
    .claim-chat-dropdown_item{
        border-bottom: 1px solid rgba(255, 255, 255, .1);
    }
    .claim-chat-dropdown_item:hover:not(.claim-chat-dropdown_item__search){
        background: var(--bs-primary) !important;
        color: var(--bs-white) !important;
    }
    .claim-chat-dropdown_items > div:not(:last-child){
        border-bottom: 1px solid rgba(0, 0, 0, .06);
    }
    @media (max-width: 575px) {
        .claim-chat-dropdown_selected span{
            min-width: auto;
        }
        .claim-chat-dropdown_items{
            min-width: 190px;
        }
    }
</style>
